export const calculatePlanPrice = (
  pricingOptions = [],
  selectedFrequency = {},
  multiplier = 1
) => {
  const selectedPrice = pricingOptions.find(
    (option) =>
      option.period === selectedFrequency.period &&
      option.period_unit === selectedFrequency.period_unit
  );
  if (selectedPrice) {
    return Number(selectedPrice.price) * multiplier;
  }
  return 0;
};
